<template lang="html">
  <div class="page-section">
    <div class="container">
      <div class="list-gallery">

        <h2 v-if="title" class="list-title" v-html="title"></h2>

        <div class="gallery">
          <div
            class="item"
            v-for="(item, index) in items"
            :key="`gallery-item-${index}`"
            @click="activateItem">
            <GalleryImage :content="image(item)"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import parseComponent from '@/mixins/parseComponent'

import GalleryImage from '@/components/Previewers/Gallery/GalleryImage'

export default {
  name: 'BasicGallery',

  mixins: [parseComponent],

  props: {
    title: String,
    demoMode: Boolean,

    currentListItem: {
      type: Object,
      description: 'This is the type of list'
    },

    items: {
      type: Array,
      description: 'The current list item'
    }
  },

  components: {
    GalleryImage
  },

  computed: {
    image() {
      return (item) => {
        return this.demoMode ? this.parse(item).image_url : item.image_versions[0].url
      }
    }
  },

  methods: {
    activateItem() {
      alert('Clicking a gallery item will show it in an overlay.')
    }
  }
}
</script>

<style lang="sass">
@import '../../stylesheets/base/variables'
@import '../../stylesheets/helpers/mixins'
@import '../../stylesheets/base/theme'

.list-gallery
  background: #fff
  box-shadow: $content-shadow

  .gallery
    .item
      margin: auto
      cursor: zoom-in

    @include media($media-gt-medium)
      display: flex
      flex-wrap: wrap
      justify-content: center

      .item
        flex-basis: percentage(1/2)
        margin: 0

    @include media($media-gt-large)
      .item
        flex-basis: percentage(1/3)

    @include media($media-gt-x-large)
      .item
        flex-basis: percentage(1/4)
</style>
